import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import zeroneLogoDark from 'assets/images/svg/logo-dark.svg'
import InputField from 'components/common/InputField'
import PrimaryButton from 'components/common/PrimaryButton'
import SecondaryButton from 'components/common/SecondaryButton'
import ZeroneLoader from 'components/common/ZeroneLoader'
import AnimatedBackgroundContainer from 'components/common/AnimatedBackgroundContainer'
import { useToast } from 'provider/ToastProvider'
import { forgotPasswordSend } from 'constants/api/endpoints/AuthEndpoints'
import styles from 'styles/components/LoginForm.module.sass'

const ForgotPasswordPage: React.FC = () => {
    const [email, setEmail]     = useState('')
    const [loading, setLoading] = useState(false)
    const { addToast } = useToast()
    const navigate = useNavigate()

    const handleSend = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!email.trim()) {
            addToast({ message: 'Please enter your email address.', type: 'error' })
            return
        }
        setLoading(true)
        const result = await forgotPasswordSend({ tag: 'ForgotPassword', data: { email: email.trim() } })
        setLoading(false)
        if (result.error) {
            addToast({ message: result.error, type: 'error' })
            return
        }
        addToast({ message: 'If that email is registered, a code has been sent.', type: 'success' })
        void navigate('/reset-password', { state: { email: email.trim() } })
    }

    return (
        <AnimatedBackgroundContainer showFooter={true}>
            <form className={styles['login-form']} onSubmit={(e) => { void handleSend(e) }}>
                <div className={styles['logo-wrapper']}>
                    <Link to="/"><img src={zeroneLogoDark} className={styles['logo']} alt="Zerone AnalytiQs Logo" /></Link>
                </div>
                {loading ? (
                    <ZeroneLoader text="Sending code..." />
                ) : (
                    <div className={styles['main-wrapper']}>
                        <div className={styles['input-wrapper']}>
                            <p style={{ fontSize: 14, color: '#374151', margin: '0 0 8px', textAlign: 'center' }}>
                                Enter your registered email and we&apos;ll send you a reset code.
                            </p>
                            <InputField
                                label="Email"
                                type="email"
                                value={email}
                                onChange={setEmail}
                                required
                            />
                        </div>
                        <div className={styles['action-buttons']}>
                            <PrimaryButton
                                text="Send Code"
                                width="auto"
                                primaryColor="#FF5522"
                                textColor="#FFFFFF"
                                hoverColor="#FFFFFF"
                                hoverTextColor="#FF5522"
                                doSomething={(e: React.FormEvent) => { void handleSend(e) }}
                            />
                            <SecondaryButton
                                text="Back to login"
                                width="auto"
                                primaryColor="transparent"
                                textColor="#ff5522"
                                hoverColor="#ff5522"
                                hoverTextColor="#FFFFFF"
                                doSomething={() => { void navigate('/login') }}
                            />
                        </div>
                    </div>
                )}
            </form>
        </AnimatedBackgroundContainer>
    )
}

export default ForgotPasswordPage
